import SmartAutocompleteBase from "../../assets/SmartAutocompleteBase";
import BaseApi from "../../api/BaseApi";
import {Cell, RichCell} from "@vkontakte/vkui";
import React from "react";


class DadataKlientsSmartAutocomplete extends SmartAutocompleteBase {

    getItems = (search_ = '', append = false, page: 1) => {

        const search = search_ ? search_ : this.state.search
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        let sAjaxSource = '/?app=' + this.props.app + '&act=' + this.props.act
        if (this.props.params) {
            sAjaxSource = sAjaxSource + '&' + this.props.params
        }
        this.setState({loading: true})

        BaseApi.post(sAjaxSource, {search, page, epp: this.state.numItems},).then((response) => {
            this.setState({loading: false})
            const items = append ? this.state.items : []
            const results = response.data.results

            results.map((el, i) => {
                el.name = el.value
                el.title = el.value
                el.uid = el.data.inn

                el.descr = el.data.inn

                el.address = el.data.address ? (el.data.address.unrestricted_value ?? '') : ''
                items.push(el)
            })

            this.setState({
                items: items,
                cnt_items: response.data.iTotalRecords,
                totalPages: 1
            })
            setTimeout(() => this.checkShowList(), 700)
        })

    }

    renderRow(el, index) {
        return <RichCell key={'autocomlete_select_obj' + index} multiline
                         subhead={el.address}
                         caption={el.descr}
                         className={el.existIn1C ? 'green-back' : ''}
                         onClick={() => this.selectObject(index)}>{el.title}</RichCell>
    }
}

export default DadataKlientsSmartAutocomplete